import { Grid } from "@mui/material"
import { FC, ReactNode } from "react"

interface IGridPresenter {
    itemRender: (item: any) => ReactNode;
    className?: string;
    items: any[];
}

const GridPresenter: FC<IGridPresenter> = ({items, itemRender, className}) => {
    return <Grid
            container
            className={className}
            spacing={1}
            alignItems="stretch"
            direction="row">
            {items?.map((item, index) => {
                return <Grid 
                    key={`grid-presenter-${index}`} 
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 4,
                        lg: 3,
                    }}
                >
                {itemRender(item)}
                </Grid>
            })}
    </Grid>
} 


export { GridPresenter }